import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { slugify, truncate, deviceChange, isMobileQuery, isTabletQuery, configQuery, FeatureEnabledV2, getItemTime, getItemDate, formatCurrency, toUtc, formatDate, formatTime } from '@gig/magic-common';
import { Watch, Component, Mixins } from 'vue-property-decorator';
import { Currency } from '@gig/magic-sdk/dist/adapter/users/signup';
import { Feature } from '@gig/magic-messages';
import { compactFormatter, getSweepRatio } from '../../utils/helpers.js';
import { namespace } from 'vuex-class';
import { TRANSACTIONS_NAMESPACE } from '../../store/modules/transactions/transactions.store.js';
import { store } from '../../store/index.js';
import { CoreXOperationType } from '@gig/magic-sdk/dist/adapter/users/getUserTransactionsHistory';
import { isFiatCurrency } from '@gig/magic-sdk/dist/util/balance';
import { SweepstakesTransactionMixin } from '../sweepstakes-transaction/transaction.js';

var transactions = namespace(TRANSACTIONS_NAMESPACE);
var RedemptionsTransactionColumn;
(function (RedemptionsTransactionColumn) {
    RedemptionsTransactionColumn["DATE"] = "date";
    RedemptionsTransactionColumn["TIME"] = "time";
    RedemptionsTransactionColumn["COINS"] = "coins";
    RedemptionsTransactionColumn["AMOUNT"] = "amount";
    RedemptionsTransactionColumn["STATUS"] = "status";
    RedemptionsTransactionColumn["PROVIDER"] = "provider";
    RedemptionsTransactionColumn["ID"] = "id";
})(RedemptionsTransactionColumn || (RedemptionsTransactionColumn = {}));
/**
 * Fetches and displays the list of bonuses
 * transactions
 */
var RedemptionsTransactionsComponent = /** @class */ (function (_super) {
    __extends(RedemptionsTransactionsComponent, _super);
    function RedemptionsTransactionsComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pageSize = 10;
        _this.Column = RedemptionsTransactionColumn;
        _this.Currency = Currency;
        /**
         * When enabled it will show the time and date
         * in local time instead of UTC.
         */
        _this.isLocalTime = false;
        /**
         * List of columns that should be displayed.
         * This property does not affect the order.
         */
        _this.columns = Object.values(RedemptionsTransactionColumn).join(',');
        _this.multiplier = 1;
        _this.isMobileOnly = false;
        _this.deviceSub = undefined;
        _this.isTablet = false;
        _this.isMobile = false;
        return _this;
    }
    Object.defineProperty(RedemptionsTransactionsComponent.prototype, "shownColumns", {
        get: function () {
            return this.columns
                .split(',')
                .map(function (str) {
                return str.trim();
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RedemptionsTransactionsComponent.prototype, "shownHistory", {
        get: function () {
            var _this = this;
            var _a;
            var truncateIfMobile = function (value) {
                return _this.isMobileOnly ? truncate(value, 12, false) : value;
            };
            return (_a = this.transactions) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                var currency = item.Payload.CurrencyCode;
                var amount = item.Payload.Amount;
                var isFiat = isFiatCurrency(currency);
                var multiplier = isFiat ? _this.multiplier : 1;
                var coins = multiplier * amount;
                var status = _this.$t("payment-transactions.status." + slugify(item.Payload.Transaction.Current.Status));
                var provider = _this.getPaymentMethod(item);
                return {
                    id: item.TransactionId,
                    date: new Date(item.TimestampEpoch),
                    currency: currency,
                    amount: isFiat ? amount : null,
                    coins: coins,
                    icon: isFiat || currency === Currency.SWP
                        ? 'sweepcoin'
                        : 'goldcoin',
                    coinsFormatted: coins && compactFormatter.format(coins),
                    status: truncateIfMobile(status),
                    provider: truncateIfMobile(provider),
                    idLabel: _this.getIdLabel(item),
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    RedemptionsTransactionsComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        configQuery('wallet.redemptionHistoryColumns', function (columns) {
                            if (!columns) {
                                return;
                            }
                            _this.columns = columns.join(',');
                            _this.columnsValidator(_this.columns);
                        });
                        this.fetchData();
                        _a = this;
                        return [4 /*yield*/, getSweepRatio()];
                    case 1:
                        _a.multiplier = _b.sent();
                        this.deviceSub = deviceChange(function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        _a = this;
                                        return [4 /*yield*/, isTabletQuery()];
                                    case 1:
                                        _a.isTablet = _c.sent();
                                        _b = this;
                                        return [4 /*yield*/, isMobileQuery()];
                                    case 2:
                                        _b.isMobile = _c.sent();
                                        this.isMobileOnly = this.isMobile && !this.isTablet;
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    RedemptionsTransactionsComponent.prototype.destroyed = function () {
        var _a;
        (_a = this.deviceSub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    };
    RedemptionsTransactionsComponent.prototype.columnsValidator = function (columns) {
        var found = columns.split(',');
        var allValues = Object.values(RedemptionsTransactionColumn);
        return found.every(function (column) {
            return allValues.includes(column.trim());
        });
    };
    RedemptionsTransactionsComponent.prototype.isColumnShown = function (column) {
        return this.shownColumns.includes(column);
    };
    RedemptionsTransactionsComponent.prototype.loadMore = function () {
        this.fetchData({ loadMore: true });
    };
    RedemptionsTransactionsComponent.prototype.fetchData = function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.loadMore, loadMore = _c === void 0 ? false : _c;
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!this.from || !this.to) {
                            return [2 /*return*/];
                        }
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        this.onContentLoadInit();
                        return [4 /*yield*/, this.fetchTransactions({
                                from: this.fromDate,
                                to: this.toDate,
                                size: this.pageSize,
                                typeFilter: CoreXOperationType.DEBIT,
                                loadMore: loadMore,
                            })];
                    case 2:
                        _d.sent();
                        this.onContentLoad(this.transactions);
                        if (loadMore) {
                            this.scrollToBottomOfPayment();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _d.sent();
                        this.onContentLoadError(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        FeatureEnabledV2({
            slug: Feature.TRANSACTIONS_HISTORY_ON_LOCAL_TIME,
        }),
        __metadata("design:type", Boolean)
    ], RedemptionsTransactionsComponent.prototype, "isLocalTime", void 0);
    __decorate([
        transactions.Getter('isLoadingState'),
        __metadata("design:type", void 0)
    ], RedemptionsTransactionsComponent.prototype, "isLoading", void 0);
    __decorate([
        transactions.Getter('hasMoreRows'),
        __metadata("design:type", void 0)
    ], RedemptionsTransactionsComponent.prototype, "hasMoreRows", void 0);
    __decorate([
        transactions.Getter('getRedemptionTransactions'),
        __metadata("design:type", void 0)
    ], RedemptionsTransactionsComponent.prototype, "transactions", void 0);
    __decorate([
        transactions.Action('fetchTransactions'),
        __metadata("design:type", Object)
    ], RedemptionsTransactionsComponent.prototype, "fetchTransactions", void 0);
    __decorate([
        Watch('from'),
        Watch('to'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], RedemptionsTransactionsComponent.prototype, "fetchData", null);
    RedemptionsTransactionsComponent = __decorate([
        Component({
            name: 'corex-redemption-transactions',
            methods: { getItemTime: getItemTime, getItemDate: getItemDate },
            store: store,
            filters: {
                formatCurrency: formatCurrency,
                toUtc: toUtc,
                formatDate: formatDate,
                formatTime: formatTime,
            },
        })
    ], RedemptionsTransactionsComponent);
    return RedemptionsTransactionsComponent;
}(Mixins(SweepstakesTransactionMixin)));

export default RedemptionsTransactionsComponent;
